/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S41_IntroInputs */

const es_tyc_obligations_s41_intro = /** @type {(inputs: Tyc_Obligations_S41_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usted puede usar el Servicio unicamente para:`)
};

const en_tyc_obligations_s41_intro = /** @type {(inputs: Tyc_Obligations_S41_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may use the Service only to:`)
};

/**
* | output |
* | --- |
* | "You may use the Service only to:" |
*
* @param {Tyc_Obligations_S41_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s41_intro = /** @type {((inputs?: Tyc_Obligations_S41_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S41_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s41_intro(inputs)
	return en_tyc_obligations_s41_intro(inputs)
});
export { tyc_obligations_s41_intro as "tyc.obligations.s41_intro" }